import { PayloadAction } from '@reduxjs/toolkit';

import { ReportsState } from '../../types';

export const setReportLoadingStatus = (
  state: ReportsState,
  action: PayloadAction<ReportsState['report']['loadingStatus']>,
) => {
  state.report.loadingStatus = action.payload;
};
